import {Component, OnInit} from '@angular/core';
import {ScheduleSlot} from "../../entities/server/ScheduleSlot";
import moment from "moment";
import {APIService} from "../../services/APIService";
import {ScheduleItem} from "./ScheduleItem";
import {MatDialog} from "@angular/material/dialog";
import {ScheduleViewComponent} from "./schedule-view/schedule-view.component";
import {ScheduleActivity} from "../../entities/server/ScheduleActivity";

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  all: ScheduleItem[] = [];

  now: ScheduleItem[] = [];
  coming: ScheduleItem[] = [];
  done: ScheduleItem[] = [];

  constructor(public apiService: APIService,
              public dialog: MatDialog) {
  }

  update() {
    // Fetch ALL schedule entries via dedicated API to avoid changing legacy getSchedule()
    this.apiService.getScheduleAll().then((allItems) => {
      const items = allItems.map((slot) => new ScheduleItem(slot));

      // Derive sections
      const sortedByStartDesc = items.sort((a, b) => b.getStart().getTime() - a.getStart().getTime());
      this.all = sortedByStartDesc;
      this.now = items.filter((item) => item.isNow());
      this.coming = items.filter((item) => !item.ended() && !item.isNow());
      this.done = items
        .filter((item) => item.ended())
        .sort((a, b) => b.getEnds().getTime() - a.getEnds().getTime());
    })
  }

  open(item: ScheduleItem) {
    this.dialog.open(ScheduleViewComponent, {data: item})
      .afterClosed().subscribe((data) => {
        // If dialog was dismissed or returned nothing, do nothing
        if (!data || typeof data !== 'object') return;
        const action = (data as any).delete
          ? this.apiService.deleteItem(item)
          : this.apiService.updateItem(item, data);
        action.then(() => {
          this.update();
        })
      })
  }

  toggleCancelled(item: ScheduleItem) {
    this.apiService.updateItem(item, {
      name: item.name, type: item.type, location: item.location,
      starts: item.starts.getTime(), ends: item.ends.getTime(),
      delayedStart: item.delayedStart?.getTime(), delayedEnd: item.delayedEnd?.getTime(),
      delayed: item.delayedStart !== undefined,
      cancelled: item.cancelled
    }).then(() => this.update());
  }

  add() {
    const now = new Date();
    const in30 = new Date(now.getTime() + 30 * 60 * 1000);
    const activity: ScheduleActivity = {
      id: 0,
      name: "",
      type: "PANEL",
      location: "MAIN"
    } as any;
    const slot: ScheduleSlot = {
      id: 0,
      activity: activity,
      timeStarts: now.toISOString(),
      timeEnds: in30.toISOString(),
      cancelled: false
    };
    const item = new ScheduleItem(slot);
    this.dialog.open(ScheduleViewComponent, {data: item})
      .afterClosed().subscribe((data) => {
        if (!data || typeof data !== 'object') return;
        // Include name in payload for creation
        const payload = {
          ...data,
          // Prefer the name provided by the dialog data; fallback to the item's current name
          name: (data as any).name ?? item.name
        };
        this.apiService.createItem(payload).then(() => this.update());
      });
  }

  ngOnInit(): void {
    this.update()
  }
}
